'use client';

import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';

import { logger } from '@/lib/default-logger';
import { authClient } from '@/lib/v2/auth/client';
import { useUser } from '@/hooks/v2/use-user';
import { toast } from '@/components/core/v2/toaster';

export function CustomSignOut(): React.JSX.Element {
  const { checkSession } = useUser();

  const handleSignOut = React.useCallback(async (): Promise<void> => {
    try {
      const { error } = await authClient.signOut();

      if (error) {
        logger.error('Sign out error', error);
        toast.error('Something went wrong, unable to sign out');
        return;
      }

      // Refresh the auth state
      await checkSession?.();
      // After refresh, GuestGuard will handle the redirect
    } catch (err) {
      logger.error('Sign out error', err);
      toast.error('Something went wrong, unable to sign out');
    }
  }, [checkSession]);

  return (
    <MenuItem component="div" onClick={handleSignOut} sx={{ justifyContent: 'center' }}>
      Sign out
    </MenuItem>
  );
}
